const SuffixPrefixWords = [
	"im-",
	"in-",
	"il-",
	"ir-",
	"non-",
	"dis-",
	"-less",
	"-able",
	"-ful",
	"-ous",
	"-ive",
	"-ent",
	"-cy",
	"-ness",
	"-ity",
	"-age",
	"-ship",
	"-ism",
	"-er",
	"-ry",
	"-ery",
	"-ance",
	"-ence",
	"-al",
	"-ant",
	"-ment",
	"-sion",
	"-tion",
	"vice-",
	"under-",
	"ultra-",
	"tri-",
	"tele-",
	"sur-",
	"super-",
	"sub-",
	"semi-",
	"re-",
	"pseudo-",
	"poly-",
	"out-",
	"neo-",
	"mono-",
	"mini-",
	"mega-",
	"mal-",
	"kilo-",
	"hyper-",
	"ex-",
	"counter-",
	"bi-",
	"auto-",
	"anti-",
	"-en",
	"-fy",
	"-ate",
	"-ise",
	"trans-",
	"pre-",
	"inter-",
	"fore-",
	"de-",
	"co-",
	"be-",
	"mis-",
	"un-",
	"over-",
	"-s",
	"-'s",
];

export default SuffixPrefixWords;
